import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconMenu: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 -6 32 32" fill="none">
    <line y1="1.5" x2="32" y2="1.5" stroke="currentColor" strokeWidth="3" />
    <line y1="10.5" x2="32" y2="10.5" stroke="currentColor" strokeWidth="3" />
    <line y1="19.5" x2="32" y2="19.5" stroke="currentColor" strokeWidth="3" />
  </Svg>
)
